import CacheStorage from "../storage/CacheStorage";
import UtilityHelper from "../utilities/UtilityHelper";
import { CompanyCodeDetails } from "../../model/app_config/AppConfigModel";
import StorageKeys from "../../const/StorageKeys";

const APP_DEFAULT_BASE_URL =
  process.env.REACT_APP_default_base_url ?? "https://communicatr.co:3004/";

export default class ApiUrls {
  static defaultBaseUrl: string = APP_DEFAULT_BASE_URL;

  static baseUrl: string = `${APP_DEFAULT_BASE_URL}user/`;
  static baseUrl2: string = APP_DEFAULT_BASE_URL;

  static defaultUrlCompany: string = `${APP_DEFAULT_BASE_URL}company/`;
  static baseUrlCompany: string = `${APP_DEFAULT_BASE_URL}company/`;

  static init = () => {
    const stored: any = CacheStorage.getValue(StorageKeys.web_app_config);
    if (UtilityHelper.isNotEmpty(stored)) {
      const companyCodeDetails: CompanyCodeDetails = JSON.parse(stored);

      this.baseUrl = `${
        companyCodeDetails.company_app_base_url ?? APP_DEFAULT_BASE_URL
      }user/`;
      this.baseUrl2 = `${
        companyCodeDetails.company_app_base_url ?? APP_DEFAULT_BASE_URL
      }`;
      this.baseUrlCompany = `${
        companyCodeDetails.company_app_base_url ?? APP_DEFAULT_BASE_URL
      }company/`;
    }
  };
}
